import React from "react";
import Navbar from '../components/Navbar/Navbar';
import Card from './../components/Commanbackgroundcard/Card';
import automationImg from "./../components/Assets/Automation & Robotic Solutions.webp";
import engineeringImg from "./../components/Assets/Engineering Services.webp";
import fixturesImg from "./../components/Assets/Fixtures & Toolings.webp";
import ergonomicImg from "./../components/Assets/Ergonomic Lift Assist.webp";
import { NavLink } from "react-router-dom";
import Footer from './../components/Footer/Footer';

const ProductsHub = () => {
  const products = [
    {
      title: "Automation & Robotic Solutions",
      content:
        "From concept to commissioning, we provide SPMs, robotic cells, and assembly lines designed to boost productivity and reduce downtime. Our solutions integrate advanced PLC controls and automation software, ensuring precision and repeatable results. Ideal for high-volume manufacturing, these systems enhance quality and efficiency across production lines.",
      image: automationImg,
      link: "/Automation_robotics",
    },
    {
      title: "Engineering Services",
      content:
        "Our engineering team delivers comprehensive solutions, including mechanical design, process optimization, and PLC programming. We focus on minimizing downtime and maximizing efficiency while maintaining quality standards. From concept to implementation, our expertise ensures seamless integration into your manufacturing workflows.",
      image: engineeringImg,
      link: "/Engineering_services",
    },
    {
      title: "Fixtures & Toolings",
      content:
        "We design and manufacture precision fixtures and tooling for welding, checking, and holding components. These solutions ensure accurate measurements, repeatable quality, and improved safety in production. Our products are engineered to meet specific manufacturing requirements and optimize assembly line performance.",
      image: fixturesImg,
      link: "/FixturesToolings",
    },
    {
      title: "Ergonomic Lift Assist & Powertrain Conveyor",
      content:
        "Our ergonomic lift assist systems and powertrain conveyors improve material handling efficiency and workplace safety. Designed for heavy components, these solutions reduce operator fatigue and increase productivity. Ideal for automotive and industrial applications, they ensure smooth, safe, and precise operations.",
      image: ergonomicImg,
      link: "/ergonomic",
    },
  ];

  return (
    <div className="min-h-screen relative">
      <Navbar />
      <Card text="PRODUCTS & SOLUTIONS" />
      {/* Products Grid Section */}
      <section className="py-16 px-6 lg:px-12">
        <div className="max-w-7xl mx-auto text-center mb-12">
          <h2 className="text-3xl lg:text-4xl font-bold text-gray-800 mb-4">
            Explore Our <span className="text-[#F49100]">Solutions</span>
          </h2>
          <p className="text-gray-700 text-base lg:text-lg leading-relaxed max-w-3xl mx-auto">
            We provide end-to-end solutions in automation, robotics, engineering services,
            and ergonomic material handling systems to optimize your processes and maximize efficiency.
          </p>
        </div>

        <div className="grid lg:grid-cols-2 md:grid-cols-2 sm:grid-cols-1 gap-10">
          {products.map((product, index) => (
            <article
              key={index}
              className="bg-white rounded-2xl shadow-md hover:shadow-xl transition transform hover:-translate-y-2 duration-500 overflow-hidden"
            >
              <div className="relative group">
                <img
                  src={product.image}
                  alt={product.title}
                  className="w-full h-64 object-cover rounded-t-2xl transition-transform duration-500 group-hover:scale-105"
                />
                {/* Optional subtle gradient overlay */}
                <div className="absolute inset-0 bg-gradient-to-t from-black/10 to-transparent rounded-t-2xl pointer-events-none"></div>
              </div>

              <div className="p-6">
                <h3 className="text-2xl font-semibold text-gray-800 mb-3">
                  {product.title}
                </h3>
                <p className="text-gray-700 mb-6 text-sm lg:text-base leading-relaxed">
                  {product.content}
                </p>
                <NavLink
                  to={product.link}
                  className="inline-block px-6 py-3 bg-[#F49100] text-white font-semibold rounded-lg hover:bg-[#d97900] transition duration-300"
                >
                  Know More
                </NavLink>
              </div>
            </article>
          ))}
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default ProductsHub;
